export default [
  {
    title: 'Admin.SideMenu.AdDebugger',
    icon: 'Boot',
    children: [
      {
        title: 'Admin.SideMenu.AdDebugger',
        route: 'ad-debugger',
      },
      {
        title: 'Admin.SideMenu.ScoreDebugger',
        route: 'admin-scoring-debug',
      },
      {
        title: 'Admin.SideMenu.RenderDebugger',
        route: 'admin-render-debug',
      },
    ],
  },
]
